export enum GlobalGridPreset {
  BASE_GRID = 'base-grid',
}
